import './index.less'
import React, { FC } from 'react'
import { useSelector } from "react-redux";

import { TStoreData, TTrackingData } from '@/interface'; 


interface TProps {
	trackingData: TTrackingData;
	bodyStyle?: any;
	itemStyle?: any;
}

const ViewsCard: FC<TProps> = (props: TProps) => {
	const { bodyStyle, itemStyle } = props;

	const storeData = useSelector((data: TStoreData) => {
        return {
			trackingData: data?.eventTracking
        };
    });
    const { trackingData } = storeData;

	return (
		<div className="jx-views-card" style={bodyStyle}>
			<div className="jx-views-card-content">
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">昨日访问次数</div>
					<div className="jx-views-card-item-number">{trackingData.totalPV || '--'}</div>
					<div className="jx-views-card-item-compare">同比/环比</div>
				</div>
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">昨日访问人数</div>
					<div className="jx-views-card-item-number">{trackingData.totalUV || '--'}</div>
					<div className="jx-views-card-item-compare">同比/环比</div>
				</div>
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">上周访问次数</div>
					<div className="jx-views-card-item-number">{trackingData.totalWeekPV || '--'}</div>
					<div className="jx-views-card-item-compare">同比/环比</div>
				</div>
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">上周访问人数</div>
					<div className="jx-views-card-item-number">{trackingData.totalWeekUV || '--'}</div>
					<div className="jx-views-card-item-compare">同比/环比</div>
				</div>
			</div>
			
		</div>
	)
}

export default ViewsCard